import React from "react";
import { OverlayTrigger, Popover, Spinner } from "react-bootstrap";

const ProductInfo = ({ productData, asin, cst, isLoading }) => {
  if (!asin || asin === "No ASIN") {
    return <span className="cst-text text-center mx-2">{cst}</span>;
  }

  if (isLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" size="sm" className="me-2" />
        <span className="cst-text text-center">{cst}</span>
      </div>
    );
  }

  if (!productData || productData._failed || productData.error) {
    return <span className="cst-text text-center mx-2">{cst}</span>;
  }

  const truncateTitle = (text, maxLength = 20) => {
    if (!text) return "";
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength).trim() + "...";
  };

  const popover = (
    <Popover id={`popover-${asin}`} style={{ maxWidth: "350px", zIndex: 9999 }}>
      <Popover.Body>
        <div className="d-flex">
          <img
            src={productData.product_photo}
            alt={productData.product_title}
            style={{
              width: "100px",
              height: "100px",
              objectFit: "contain",
              marginRight: "15px",
            }}
          />
          <div>
            <h6>{productData.product_title}</h6>
            <p className="mb-1">
              <strong>ASIN:</strong> {productData.asin}
            </p>
            <p className="mb-1">
              <strong>Rating:</strong> {productData.product_star_rating} ⭐ (
              {productData.product_num_ratings} reviews)
            </p>
            <p className="mb-0">
              <strong>Price:</strong> {productData.product_price}
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-around mt-3">
          <a
            href={productData.product_url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-secondary"
          >
            View on Amazon
          </a>
          <button
            className="btn btn-sm btn-light"
            onClick={() => navigator.clipboard.writeText(asin)}
          >
            Copy ASIN
          </button>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 600, hide: 800 }}
      overlay={popover}
    >
      <div className="d-flex align-items-center justify-content-center" style={{ cursor: "pointer" }}>
        <img
          src={productData.product_photo}
          alt={productData.product_title}
          style={{
            width: "40px",
            height: "40px",
            objectFit: "contain",
            marginRight: "10px",
          }}
        />
        <div>
          <div
            style={{ fontWeight: "bold", fontSize: "14px", textAlign: "left" }}
            title={productData.product_title}
          >
            {truncateTitle(productData.product_title, 20)}
          </div>
          <div style={{ fontSize: "12px", color: "#666", textAlign: "left" }}>
            {productData.asin}
          </div>
        </div>
      </div>
    </OverlayTrigger>
  );
};

export default ProductInfo;
